import { api } from "./api";

/**
 * Baixa um arquivo pelo cliente HTTP autenticado.
 *
 * Link direto não serve: a sessão é por token no cabeçalho, e não por cookie,
 * então o navegador não o enviaria. O nome do arquivo é montado aqui porque o
 * Content-Disposition da resposta só chegaria ao JavaScript se a API o
 * expusesse explicitamente no CORS.
 */
const salvar = (conteudo: Blob, nomeArquivo: string) => {
  const url = URL.createObjectURL(conteudo);
  const link = document.createElement("a");
  link.href = url;
  link.download = nomeArquivo;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

export const baixarGet = async (
  caminho: string,
  parametros: Record<string, unknown>,
  nomeArquivo: string
): Promise<void> => {
  const { data } = await api.get<Blob>(caminho, {
    params: parametros,
    responseType: "blob",
  });
  salvar(data, nomeArquivo);
};

export const baixarPost = async (
  caminho: string,
  corpo: unknown,
  nomeArquivo: string
): Promise<void> => {
  const { data } = await api.post<Blob>(caminho, corpo, {
    responseType: "blob",
  });
  salvar(data, nomeArquivo);
};

/**
 * Erro de download vem como Blob, não como JSON, por causa do responseType.
 * Esta função lê o corpo para a tela conseguir mostrar o motivo real em vez de
 * "erro inesperado".
 */
export const lerErroDeBlob = async (erro: unknown): Promise<string | null> => {
  const resposta = (erro as { response?: { data?: unknown } })?.response?.data;
  if (!(resposta instanceof Blob)) return null;
  try {
    const texto = await resposta.text();
    const corpo = JSON.parse(texto) as { title?: string; detail?: string };
    return [corpo.title, corpo.detail].filter(Boolean).join(": ") || null;
  } catch {
    return null;
  }
};
